import React from 'react';
import styled from 'styled-components';
import { InputErrors } from './WithErrors';

type Option = {
  label: string;
  value: string | number;
};

type Props = {
  className?: string;
  options?: Option[];
  value?: (string | number)[];
  errors?: string[];
  onChange?: (value: (string | number)[]) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>;

const Input = styled.input``;
const Span = styled.span`
  margin: 0 8px;
`;

const MultipleCheckBoxes = ({
  value = [],
  options = [],
  onChange,
  className = '',
  errors,
  ...rest
}: Props) => {
  const onCheck = (option: Option) => () => {
    const v = [...value];
    const vindex = v.indexOf(option.value);
    if (vindex === -1) {
      v.push(option.value);
    } else {
      v.splice(vindex, 1);
    }
    onChange?.(v);
  };

  return (
    <InputErrors errors={errors}>
      {options.map((option, index) => (
        <Span key={`${className}-checkbox-${option.label}-${option.value}`}>
          <label htmlFor={`${className}-checkbox-${index}`}>{option.label}</label>
          <Input
            {...rest}
            type="checkbox"
            id={`${className}-checkbox-${index}`}
            className={className}
            checked={value.indexOf(option.value) !== -1}
            onChange={onCheck(option)}
          />
        </Span>
      ))}
    </InputErrors>
  );
};

export default styled(MultipleCheckBoxes)``;
